import { GetterTree } from 'vuex/types'
import { RootState } from '~/store/store.types'
import { getResource } from '~/utils/store'
import { GuestListsState, GuestListResource } from './guest-lists.types'

const getters: GetterTree<GuestListsState, RootState> = {
  resourceById (state, _, __, rootGetters) {
    return (listId: string) => {
      return getResource<GuestListResource>(state, listId, rootGetters, ['invites', 'venue'])
    }
  }
}

export default getters
